import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader/Loader";
import { useParams, useLocation } from "react-router-dom";
import LpActions from "../LandingPages/LpActions";
import { connect } from "react-redux";
import { WhyChooseUs } from "../packageDetailsPage/Newlp";
import { Steps } from "../LandingPages/Lp";
import { FiPhone, FiMail } from "react-icons/fi";
import Apointment from "../homePage/Components/Apointment";
import Featured from "../homePage/Components/Featured";
import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import Content from "../homePage/Components/Content";

import { getCall } from "../../Redux/Actions";
import { useDispatch } from "react-redux";

import Lp7form from "./Lp7form";
import TestCr from "../homePage/TestCr";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";
import "./Lp7.css";

function Lp7(props) {
  const [footerTel, setTelNum] = useState("898 898 8585");

  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");

  const [leadSource, setleadSource] = useState("Ecommerce");
  const [disable, setDisable] = useState(true);
  const [successBtn, setSuccessBtn] = useState(false);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  const params = useParams();

  const packageSlug = params?.slug;
  const dispatch = useDispatch();
  useEffect(() => {
    props.getLppackageDetails(packageSlug);
  }, [packageSlug]);

  const location = useLocation();
  var url = `https://redcliffelabs.com${location.pathname}/top${location.search}`;
  var bottomUrl = `https://redcliffelabs.com${location.pathname}/bottom${location.search}`;
  let packDetail = props?.package;
  console.log(props, "sd");
  console.log("details", packDetail);

  if (packDetail && packDetail) {
    try {
      if (packDetail?.package_city_metainfo) {
        var faqData = JSON.parse(packDetail?.package_city_metainfo?.faq);
      } else if (packDetail?.faq) {
        var faqData = JSON.parse(packDetail?.faq);
        console.log("pacakdetail", faqData);
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }
  }

  ///handel username
  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //validate phone Number
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number*");
      return false;
    } else {
      return true;
    }
  };

  //validation on submit button
  useEffect(() => {
    if (userName == "" || userNumber == "") {
      setDisable(true);
      // console.log("inside if");
    } else {
      setDisable(false);
      // console.log("inside else");
    }
  }, [userName, userNumber]);
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };
  ////////////Handel submit
  const handelSubmit = (e) => {
    e.preventDefault();
    console.log("clicked");
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: leadSource,
        city: "",
        url: bottomUrl,
      };

      setUserNumber("");
      setUserName("");
      setSuccessBtn(true);
      setTimeout(() => {
        setSuccessBtn(false);
      }, 2000);
      setPhoneEror("");

      dispatch(getCall(body));
    }
  };

  const scrollTop = () => {
    window.scroll({
      top: 340,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  return (
    <div className="lp7">
      {props.loading ? (
        <Loader />
      ) : (
        <div className="lp7Main ">
          <div className="mobileViewHeader">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg"
              width="140px"
              style={{ margin: "0 3rem" }}
              alt="logo"
            />
          </div>
          <div className="MobileBaneer ">
            <div>
              {/* <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/fda423d0-c0bd-4e2a-9ff5-021774f282ee.png"
                alt="banenr"
                width="100%"
              /> */}
              <div className="lp7Leftside flex1">
                <div className="packContainer">
                  <h1>{packDetail?.name}</h1>
                  <h4 className="testParams_New">
                    Test {packDetail.parameter > 1 ? "Parameters" : "Parameter"}{" "}
                    : {packDetail.parameter}{" "}
                    {packDetail.parameter > 1 ? "Tests" : "Test"}
                  </h4>
                  <p className="pacDesc">{packDetail?.description}</p>
                  <div className="lp7paarentForm hideMobile">
                    <div className="packagePrice">
                      <span className="Mrplp7">
                        Rs. {packDetail?.package_price}
                      </span>
                      <span className="OfferPricelp7">
                        @Rs. {packDetail?.offer_price}
                      </span>
                    </div>
                    <Lp7form
                      // param={"xxx"}
                      url={url}
                      number={footerTel && footerTel}
                    />
                  </div>
                </div>
              </div>
            </div>

            {packDetail?.tat_time && packDetail?.tat_time !== "" ? (
              <div className="CardInfo">
                <div className="packMobileCard">
                  <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d152d70c-9b73-4a04-bf4a-d715784d2177.svg" />
                  <span className="tatDetails">
                    <span style={{ color: "#707070", fontWeight: "400" }}>
                      Get Reports in
                    </span>
                    <span> {packDetail && packDetail?.tat_time}</span>
                  </span>
                </div>
              </div>
            ) : null}

            {packDetail?.recommended_age &&
            packDetail?.recommended_age !== "" ? (
              <div className="CardInfo">
                <div className="packMobileCard">
                  <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d152d70c-9b73-4a04-bf4a-d715784d2177.svg" />
                  <span className="tatDetails">
                    <span style={{ color: "#707070", fontWeight: "400" }}>
                      Age Group
                    </span>
                    <span> {packDetail && packDetail?.recommended_age}+</span>
                  </span>
                </div>
              </div>
            ) : null}

            {packDetail?.specimen_instructions &&
            packDetail?.specimen_instructions !== "" ? (
              <div className="CardInfo">
                <div className="packMobileCard">
                  <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d152d70c-9b73-4a04-bf4a-d715784d2177.svg" />
                  <span className="tatDetails">
                    <span style={{ color: "#707070", fontWeight: "400" }}>
                      Sample Collection
                    </span>
                    <span>
                      {" "}
                      {packDetail && packDetail?.specimen_instructions}
                    </span>
                  </span>
                </div>
              </div>
            ) : null}

            {packDetail?.fasting_time && packDetail?.fasting_time !== "" ? (
              <div className="CardInfo">
                <div className="packMobileCard">
                  <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d152d70c-9b73-4a04-bf4a-d715784d2177.svg" />
                  <span className="tatDetails">
                    <span style={{ color: "#707070", fontWeight: "400" }}>
                      Fasting Required
                    </span>
                    <span> {packDetail && packDetail?.fasting_time}</span>
                  </span>
                </div>
              </div>
            ) : null}

            <div className="SubmitFormLp">
              <div className="lpFormTop">
                <div className="blueDiv">
                  <span>{packDetail?.parameter}</span>
                  <span>{packDetail?.parameter > 1 ? "Tests " : "Test"}</span>
                </div>
                <div className=" Mrp nextChild">
                  <span> MRP</span>
                  <span style={{ textDecoration: "line-through" }}>
                    ₹ {packDetail?.package_price}
                  </span>
                </div>
                <div className="offer nextChild">
                  <span>Offer Price</span>
                  <span style={{ fontWeight: "800" }}>
                    ₹ {packDetail?.offer_price}
                  </span>
                </div>
              </div>
              <div className="BookTest">
                <span style={{ marginLeft: "2rem" }}>Book Your Test</span>
                {packDetail?.offer_price > 499 ? (
                  <div className="freeSample">
                    With{" "}
                    <span style={{ fontWeight: "600" }}>
                      {" "}
                      &nbsp; FREE HOME SAMPLE COLLECTION
                    </span>
                  </div>
                ) : (
                  <div className="freeSample">
                    With{" "}
                    <span style={{ fontWeight: "600" }}>
                      {" "}
                      &nbsp; HOME SAMPLE COLLECTION
                    </span>
                  </div>
                )}
              </div>
              <div className="mobileDivForm">
                <Lp7form />
              </div>
            </div>
          </div>
          <div className="lp7container">
            <div className="lp7Leftside hideMobile flex1">
              <div className="packContainer">
                <h1>{packDetail?.name}</h1>
                <h4 className="testParams">
                  Test {packDetail.parameter > 1 ? "Parameters" : "Parameter"} :
                  {packDetail.parameter}{" "}
                  {packDetail.parameter > 1 ? "Tests" : "Test"}
                </h4>
                <p className="pacDesc">{packDetail?.meta_description}</p>
                <div className="lp7paarentForm hideMobile">
                  <div className="packagePrice">
                    <span className="Mrplp7">
                      Rs. {packDetail?.package_price}
                    </span>
                    <span className="OfferPricelp7">
                      @Rs. {packDetail?.offer_price}
                    </span>
                  </div>
                  <Lp7form buttonId={"LpTop"} formId={"LpForm"} url={url} />
                </div>
              </div>
            </div>
            <div className="lp7RightSide flex1">
              <div className="redLogo hideMobile">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg"
                  width="80%"
                  alt="logo"
                />
              </div>
              <div className="lpimageContainer_New">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8b364f1e-f4ac-4d66-bb31-c0526de71a25.png"
                  alt="banner"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
          <div className="spaceContiner" />
          <div className="newCardslp hideMobile">
            <div className="NewlpDivRow">
              {packDetail && packDetail?.tat_time ? (
                <div className="lpcards">
                  <div className="card__imglp">
                    <img
                      src={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                      }
                      alt={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                      }
                      width="100%"
                    />
                  </div>
                  <div className="card__contentlp">
                    <span className="mainHeading">Get Reports in</span>
                    <span className="redHeading">{packDetail.tat_time}</span>
                  </div>
                </div>
              ) : null}
              {packDetail && packDetail.fasting_time ? (
                <div className="lpcards">
                  <div className="card__imglp">
                    <img
                      src={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                      }
                      width="100%"
                      alt={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                      }
                    />
                  </div>
                  <div className="card__contentlp">
                    <span className="mainHeading"> Fasting Requirement</span>
                    <span className="redHeading">
                      {packDetail.fasting_time}
                    </span>
                  </div>
                </div>
              ) : null}
              {/**sample information */}
              {packDetail && packDetail.sample ? (
                <div className="lpcards">
                  <div className="card__imglp">
                    <img
                      src={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                      }
                      alt={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                      }
                      width="100%"
                    />
                  </div>
                  <div className="card__contentlp">
                    <span className="mainHeading">Sample Collection</span>
                    <span className="redHeading">{packDetail.sample}</span>
                  </div>
                </div>
              ) : null}

              {/**Home collection packDetail.home_collection */}
              {packDetail && packDetail.home_collection ? (
                <div className="lpcards">
                  <div className="card__imglp">
                    <img
                      width="100%"
                      src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/365b77d0-1404-4a54-ba19-5dec81bec29c.svg"
                    />
                  </div>
                  <div className="card__contentlp">
                    <span className="mainHeading">Home Collection</span>
                    <span className="redHeading">Available</span>
                  </div>
                </div>
              ) : null}

              {packDetail && packDetail.recommended_age ? (
                <div className="lpcards">
                  <div className="card__imglp">
                    <img
                      src={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                      }
                      alt={
                        "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                      }
                      width="100%"
                    />
                  </div>
                  <div className="card__contentlp">
                    <span className="mainHeading">Age Group</span>
                    <span className="redHeading">
                      {packDetail.recommended_age} years
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <WhyChooseUs />
          <Steps />

          <Apointment
            parentPath="lpPage"
            img={
              "https://staticcdn.redcliffelabs.com/media/gallary-images/None/76164f75-aed7-4ac1-a401-c23961ee59e7.webp"
            }
            butname="BOOK TEST NOW"
          />
          <Featured />
          <Content
            title="Testimonials"
            Ispackage={false}
            isTestimonial={true}
          />
          {faqData == "" ? null : props?.loading ? (
            <Loader />
          ) : (
            <TestCr faq={faqData && faqData !== "" && faqData} />
          )}
          <div className="footerLp">
            <div className="footerContainer">
              <div className="footerFirstRow">
                <div className="logoIMg">
                  <img
                    width="100%"
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                    alt="logo"
                  ></img>
                </div>
                <div className="footerDesc">
                  <p>
                    Redcliffe Labs is an accredited advanced diagnostic
                    laboratory that aims at providing top-notch consistent and
                    accurate laboratory services with modern technology and
                    equipment all inclusive of logistics management.
                  </p>
                </div>
              </div>
              <div className="footerSecondRow">
                <div className="footerLogo">
                  <span>Contact Us</span>
                  <div className="emailLogo">
                    <span>
                      <FiMail />
                    </span>
                    care@redcliffelabs.com
                  </div>
                  <a href={`tel:+91${footerTel}`}>
                    <div className="phoneLogo">
                      <span>
                        <FiPhone />
                      </span>
                      {footerTel}
                    </div>
                  </a>
                </div>
              </div>
              <div className="borderDiv"></div>
              <div className="footerThirdRow">
                <div className="footerMsg">
                  <p style={{ marginRight: "3rem" }}>
                    Redcliffe Labs <br /> © 2022. All rights reserved.
                  </p>
                  <p>
                    Disclaimer: As per "Pre-Natal Diagnostic Techniques
                    (Regulation and prevention of Misuse) Act, 1994", our labs
                    strictly does not determine the sex of the fetus.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/***FIXED FOOTER */}
          <div className="Lpfooter">
            <div className="lpfooter__content">
              <form id="LpBottomForm" onSubmit={handelSubmit}>
                <div className="nameInput ">
                  Name
                  <input
                    type="text"
                    onChange={handelUserName}
                    className={nameError ? "colorRed" : ""}
                    placeholder={nameError ? nameError : "Enter Name"}
                    value={nameError ? () => setUserName("") : userName}
                  ></input>
                </div>
                <div className="phoneInput">
                  Phone Number
                  <input
                    type="text"
                    className={phoneError ? "colorRed" : ""}
                    placeholder={phoneError ? phoneError : "Enter Phone Number"}
                    value={phoneError ? () => setUserName("") : userNumber}
                    onChange={handelPhoneChange}
                    required
                  ></input>
                </div>
                <div className="verticle" />

                {successBtn ? (
                  <div className="submitButton__lpfooter">
                    <button
                      disabled="disabled"
                      className="btnSuccess"
                      type="submit"
                    >
                      Success
                    </button>
                  </div>
                ) : (
                  <div className="submitButton__lpfooter">
                    <button
                      id="Lpbottom"
                      disabled={nameError || disable ? "disabled" : null}
                      className={nameError || disable ? "disabled" : null}
                      type="submit"
                    >
                      Book Now
                    </button>
                  </div>
                )}
              </form>
            </div>

            <button id="MobFotterButton" onClick={scrollTop}>
              Book Free Consultation
            </button>
          </div>

          {/* Notification popup */}
          <Modal
            classNames={{
              overlay: "customOverlay",
              modal: "notificationPopup_modal",
            }}
            open={open1}
            onClose={onCloseModal1}
            center
          >
            <Popup setOpen={setOpen1} />
          </Modal>

          <ScrolltoTop />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  package: state?.lpPackage?.lpPackageData,
  loading: state?.lpPackage?.loadinglp,
  success: state?.lpPackage?.success,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLppackageDetails: (lpslug) => {
      dispatch(LpActions.getLppackageDetails(lpslug));
    },
    getCall: (body) => {
      dispatch(LpActions.getCall(body));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Lp7)),
};
